import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function JoinRightIcon(props: IconProps) {
    return <Icon {...props} iconKey={"join_right"}/>
}
